<div class="row list-container mat-card" [hidden]="projectChartService.loading$ | async">
    <div class="col-12 mb-2">
        <h3>{{ 'projects.order-vs-billing' | translate }}</h3>
    </div>
    @if (orderEntryVsBillingEntry) {
        <div class="col-12">
            <ceres-chart
                [data]="orderEntryVsBillingEntry"
                [height]="view[1]"
                [colors]="colorScheme"
                [legend]="showLegend"
                [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel"
            ></ceres-chart>
        </div>
    }
</div>
@if (projectChartService.loading$ | async) {
    <ceres-loading></ceres-loading>
}
